import { request } from './request';

export default {
  /**
   * 合同用户权限
   * @param {*} ContractId 合同Id
   */
  getContractBase(contract_id, OrderNo, PageAction, Unit) {
    return request({
      url: '/contract/getContractBase',
      method: 'get',
      params: {
        contract_id,
        OrderNo,
        PageAction,
        Unit,
      },
    });
  },
  /**
   * 获取合同信息Id
   * @param {*} ContractNo
   * @returns
   */
  getContracIdByContractNo(ContractNo) {
    return request({
      url: '/contract/getOrderContractIdByContractNo',
      method: 'get',
      params: {
        ContractNo,
      },
    });
  },
  /**
   * 合同信息或生成合同信息
   * @param {Number} id 合同Id
   * @returns
   */
  getContractOrNew(id) {
    return request({
      url: '/contract/getContractOrNew',
      method: 'get',
      params: {
        id,
      },
    });
  },
  /**
   * 合同主信息
   * @param {Number} id
   */
  getContract(id) {
    return request({
      url: `/Contract/${id}`,
      method: 'get',
    });
  },
  /**
   * 合同主信息
   * @param {Number} id
   */
  getOrderContract(Id, Unit) {
    return request({
      url: `/Contract/GetOrderContract`,
      method: 'get',
      params: {
        Id,
        Unit,
      },
    });
  },
  /**
   * 合同预定信息
   * @param {Number} OrderContractId
   * @returns
   */
  getOrderBookingByContractId(OrderContractId) {
    return request({
      url: '/contract/GetOrderContractBookingByContractId',
      method: 'get',
      params: {
        OrderContractId,
      },
    });
  },
  /**
   * 更新合同主信息
   * @param {*} ordercontract 实体类
   */
  changeOrderContract(ordercontract) {
    return request({
      url: '/Contract/changeOrderContract',
      method: 'post',
      data: ordercontract,
    });
  },
  /**
   * 更新合同预定信息
   * @param {*} ordercontract 实体类
   */
  changeOrderContractBooking(booking) {
    return request({
      url: '/Contract/changeOrderContractBooking',
      method: 'post',
      data: booking,
    });
  },
  /**
   * 新增媒体
   * @param {Array} Medias
   * @returns
   */
  AddMediaItems(Medias) {
    return request({
      url: '/Contract/AddContractMediaItems',
      method: 'post',
      data: Medias,
    });
  },
  /**
   * 合同媒体明细
   * @param {Number} ContractId 合同Id
   * @returns
   */
  ContractMediaItems(ContractId) {
    return request({
      url: '/Contract/getContractMediaItems',
      method: 'get',
      params: {
        ContractId,
      },
    });
  },
  /**
   * 获取正在编辑中的媒体信息
   * @param {Number} Id
   * @returns
   */
  getEditMediaItem(Id) {
    return request({
      url: '/Contract/getEditMediaItem',
      method: 'get',
      params: { Id },
    });
  },
  /**
   * 批量更新合同媒体
   * @param {Array} Medias
   * @returns
   */
  changeMediaItems(Medias) {
    return request({
      url: '/Contract/changeContractMediaItems',
      method: 'post',
      data: Medias,
    });
  },
  /**
   * 修改合同媒体
   * @param {Object} ContractMedia
   * @returns
   */
  modifyContractMediaItem(ContractMedia) {
    return request({
      url: '/Contract/modifyContractMediaItem',
      method: 'post',
      data: ContractMedia,
    });
  },
  /**
   * 验证媒体是否可以删除
   * @param {Number} Id
   */
  ValidDeleteMediaItem(Id) {
    return request({
      url: '/Contract/ValidDeleteMediaItem',
      method: 'get',
      params: { Id },
    });
  },
  /**
   * 删除合同媒体
   * @param {Number} Id
   * @returns
   */
  deleteMediaItem(Id) {
    return request({
      url: '/Contract/deleteContractMediaItem',
      method: 'delete',
      params: {
        Id,
      },
    });
  },
  /**
   * 删除合同媒体
   * @param {Array} Ids
   * @returns
   */
  deleteContractMediaItemsByContractId(ContractId) {
    return request({
      url: '/Contract/deleteContractMediaItemsByContractId',
      method: 'delete',
      params: {
        ContractId,
      },
    });
  },
  /**
   * 生成Opertation Instruction
   * @param {Number} ContractId 合同Id
   */
  CreateContractOperationInstruction(ContractId) {
    return request({
      url: '/Contract/CreateContractOperationInstruction',
      method: 'post',
      params: {
        ContractId,
      },
    });
  },
  /**
   * Operation Instruction 明细
   * @param {Number} ContractId 合同Id
   * @returns
   */
  ContractOperationInstructionDetails(ContractId) {
    return request({
      url: '/Contract/ViewContractOperationInstructions',
      method: 'get',
      params: {
        ContractId,
      },
    });
  },
  /**
   * 修改operation instruction
   * @param {Object} ContractMedia
   * @returns
   */
  modifyOperationInstruction(ContractMedia) {
    return request({
      url: '/Contract/modifyOperationInstruction',
      method: 'post',
      data: ContractMedia,
    });
  },
  /**
   * 批量更新OperationInstruction
   * @param {Array} OperationInstructions
   */
  saveContractOperationInstruction(OperationInstructions) {
    return request({
      url: '/Contract/saveContractOperationInstruction',
      method: 'post',
      data: OperationInstructions,
    });
  },
  /**
   * 换画
   * @param {RequestProductionChange} change
   * @returns
   */
  ChangeContractProductionChange(change) {
    return request({
      url: '/Contract/changeContractProductionChange',
      method: 'post',
      data: change,
    });
  },
  /**
   * 换画记录
   * @param {Number} ContractId
   * @returns
   */
  getOperationSummary(ContractId) {
    return request({
      url: '/Contract/getOperationSummary',
      method: 'get',
      params: {
        ContractId,
      },
    });
  },
  /**
   * 生成Contract Internal Split
   * @param {Number} ContractId 合同Id
   * @returns
   */
  RegenerateContractInternalSplit(ContractId, bRegenerate) {
    return request({
      url: '/Contract/RegenerateContractInternalSplit',
      method: 'post',
      params: {
        ContractId,
        bRegenerate: bRegenerate || false,
      },
    });
  },
  /**
   * 生成Contract Internal Split
   * @param {Number} ContractId 合同Id
   * @returns
   */
  ContractInternalSplit(Id, ContractId) {
    return request({
      url: '/Contract/ContractInternalSplit',
      method: 'get',
      params: {
        Id,
        ContractId,
      },
    });
  },
  /**
   * 计算Internal Split
   * @param {Number} Id SplitId
   * @param {Number} MediaNett
   * @param {Number} ServiceFee
   * @returns
   */
  CalculateInternalSplit(CalculateSplit) {
    return request({
      url: '/Contract/CalculateInternalSplit',
      method: 'post',
      data: CalculateSplit,
    });
  },
  /**
   * 保存Internal Split
   * @param {Object} SplitInfo
   * @returns
   */
  saveContractInternalSplit(SplitInfo) {
    return request({
      url: '/Contract/saveContractInternalSplit',
      method: 'post',
      data: SplitInfo,
    });
  },
  /**
   * 复制Internal Split Media
   * @param {Number} SplitDetailId Internal Split Media Id
   * @returns
   */
  copyContractInternalSplit(SplitDetailId) {
    return request({
      url: '/Contract/copyContractInternalSplit',
      method: 'post',
      params: {
        SplitDetailId,
      },
    });
  },
  /**
   * 删除Internal Split Media
   * @param {Number} SplitDetailId Internal Split Media Id
   * @returns
   */
  deleteContractInternalSplit(SplitDetailId) {
    return request({
      url: '/Contract/deleteContractInternalSplit',
      method: 'delete',
      params: {
        SplitDetailId,
      },
    });
  },
  /**
   * 更新Intl Split Media
   * @param {Object} SplitMedia
   * @returns
   */
  changeContractInternalSplit(SplitMedia) {
    return request({
      url: '/Contract/changeContractInternalSplit',
      method: 'post',
      data: SplitMedia,
    });
  },
  /**
   * 获取Production Cost Split
   * @param {Number} SplitDetailId
   */
  getProductionCostSplit(SplitDetailId) {
    return request({
      url: '/Contract/getProductionCostSplit',
      method: 'get',
      params: { SplitDetailId },
    });
  },
  /**
   * 制作费分拆列表
   * @param {Number} ContractId 合同Id
   */
  getProductionSplitList(ContractId) {
    return request({
      url: '/Contract/getProductionSplitList',
      method: 'get',
      params: { ContractId },
    });
  },
  /**
   * 保存 Production Cost Split
   * @param {Object} ProductionSplit ProductionSplit
   * @returns
   */
  changeProductionSplit(ProductionSplit) {
    return request({
      url: '/Contract/changeProductionSplit',
      method: 'post',
      data: ProductionSplit,
    });
  },
  getSpecialCommissionArrangement(SplitMediaId) {
    return request({
      url: '/Contract/getSpecialCommissionArrangement',
      method: 'get',
      params: {
        SplitMediaId,
      },
    });
  },
  /**
   * 获取拆分媒体的特殊佣金安排列表
   * @param {Number} ContractId 合同Id
   * @returns
   */
  getSpecialCommissionArrangementList(ContractId) {
    return request({
      url: '/Contract/getSpecialCommissionArrangementList',
      method: 'get',
      params: {
        ContractId,
      },
    });
  },
  /**
   * 保存特殊佣金安排
   * @param {Object} Commission
   * @returns
   */
  SaveSpecialCommissionArrangement(Commission) {
    return request({
      url: '/Contract/SaveSpecialCommissionArrangement',
      method: 'post',
      data: Commission,
    });
  },
  /**
   * 获取GetContractDwonUrl的下载地址
   * @param  {Number} ContractId 合同Id
   * @returns
   */
  GetContractDwonUrl(ContractDraftId, bSave) {
    return request({
      url: '/Contract/GetContractDwonUrl',
      method: 'get',
      params: {
        ContractDraftId,
        bSave,
      },
    });
  },
  /**
   * 获取GetContractDwonUrl的下载地址
   * @param  {Number} ContractId 合同Id
   * @returns
   */
  DownloadPDF(dId, isPreview) {
    return request({
      url: '/Contract/DownloadPDF',
      method: 'get',
      params: {
        dId,
        isPreview,
      },
      responseType: 'blob',
    });
  },
  /**
   * 允许下载PDF
   * @param {Number} ContractDraftId
   */
  CanContractDown(ContractDraftId) {
    return request({
      url: '/Contract/CanContractDown',
      method: 'get',
      params: {
        ContractDraftId,
      },
    });
  },
  /**
   * 获取DraftContract页面数据
   * @param  {Number} ContractId 合同Id
   * @returns
   */
  GetDraftContractInfo(ContractId) {
    return request({
      url: '/Contract/GetDraftContractInfo',
      method: 'get',
      params: {
        ContractId,
      },
    });
  },
  /**
   * 获取GetContractDwonUrl的下载地址
   * @param {Object} ProductionSplit ProductionSplit
   * @returns
   */
  getAdditionalProduction(ContractId) {
    return request({
      url: '/Contract/getAdditionalProdution',
      method: 'get',
      params: {
        ContractId,
      },
    });
  },
  /**
   * 获取合同类型
   * @param {Number} ContractId 合同Id
   * @returns
   */
  getContractType(id) {
    return request({
      url: '/Contract/getContractType',
      method: 'get',
      params: {
        id,
      },
    });
  },
  /**
   * 保存DraftContract
   * @param {Object} data
   * @returns
   */
  SaveDraftContract(data) {
    return request({
      url: '/Contract/SaveDraftContract',
      method: 'post',
      data,
    });
  },
  /**
   * 重置/自动更新Draft Contract
   * @param {*} ContractId
   * @returns
   */
  RegenerateDraftContract(ContractId) {
    return request({
      url: '/Contract/RegenerateDraftContract',
      method: 'post',
      params: {
        ContractId,
      },
    });
  },
  /**
   * 合同摘要信息
   * @param {Number} OrderId 订单Id
   * @param {Number} ContractId 合同Id
   * @returns
   */
  getContractSummary(OrderId, Contract_Id) {
    return request({
      url: '/Contract/getContractSummary',
      method: 'get',
      params: {
        OrderId,
        Contract_Id,
      },
    });
  },
  /**
   * 提交合同到审批
   * @param {Number} ContractId 合同Id
   * @returns
   */
  submitContract(data) {
    return request({
      url: '/Contract/submitContract',
      method: 'post',
      data,
    });
  },
  /**
   * 提交工作单到审批
   * @param {Number} ContractId 合同Id
   * @returns
   */
  submitJob(data) {
    return request({
      url: '/Contract/submitJob',
      method: 'post',
      data,
    });
  },
  /**
   * 提交合同到审批
   * @param {Number} ContractId 合同Id
   * @returns
   */
  voidContract(Contract_Id) {
    return request({
      url: '/Contract/voidContract',
      method: 'post',
      params: {
        Contract_Id,
      },
    });
  },
  /**
   * 审批合同
   * @param {Number} ContractId 合同Id
   * @returns
   */
  approveContract(ApproveModel) {
    return request({
      url: '/Contract/ApproveContract',
      method: 'post',
      data: ApproveModel,
    });
  },
  /**
   * 批量审批合同
   * @param {Object} ContractIds 合同Id
   * @returns
   */
  bulkApproveContract(ContractIds) {
    return request({
      url: '/Contract/BulkApproveContract',
      method: 'post',
      data: ContractIds,
    });
  },
  /**
   * 根据ContractNumber获取id和orderNo等信息
   * @param {string} ContractNumber
   * @returns
   */
  getContractInfo(ContractNumber) {
    return request({
      url: '/Contract/GetContractInfo',
      method: 'get',
      params: {
        ContractNumber,
      },
    });
  },
  RemoveContractPDF(ContractDraftId, uid, UploadType) {
    var data = new FormData();
    data.append('ContractDraftId', ContractDraftId);
    data.append('uid', uid);
    data.append('UploadType', UploadType);

    return request({
      url: '/Contract/RemoveContractPDF',
      method: 'post',
      data,
    });
  },
  /**
   * Revise
   * @param {*} ContractId
   * @param {*} Contract_Id
   */
  ReviseContract(data) {
    return request({
      url: '/Contract/ReviseContract',
      method: 'post',
      data,
    });
  },
  getApprovalHistories(contract_id) {
    return request({
      url: '/Contract/getApprovalHistories',
      method: 'get',
      params: {
        contract_id,
      },
    });
  },
  /**
   * 启用Sales Revise
   * @param {*} contract_id
   * @returns
   */
  ReviseUnlock(contract_id) {
    return request({
      url: '/Contract/ReviseUnlock',
      method: 'post',
      params: {
        contract_id,
      },
    });
  },
  /**
   * 下载合同文件
   * @param {*} contract_id 合同id
   * @param {*} action 合同类型
   * @returns
   */
  downloadContract(contract_id, action, FileId, UploadType) {
    return request({
      url: '/Contract/downloadContract',
      method: 'get',
      params: {
        contract_id,
        action,
        FileId,
        UploadType,
      },
      responseType: 'blob',
    });
  },
  /**
   * 修改保存CombinedContractRequired
   * @param {Object} data
   * @returns
   */
  SaveCombinedContractRequired(data) {
    return request({
      url: '/Contract/SaveCombinedContractRequired',
      method: 'post',
      data,
    });
  },
  /**
   * 修改保存ContractBillingAddress
   * @param {Object} data
   * @returns
   */
  SaveContractBillingAddress(data) {
    return request({
      url: '/Contract/SaveContractBillingAddress',
      method: 'post',
      data,
    });
  },
  /**
   * 获取合同号
   * @returns
   */
  GetContractNo(
    CompanyEntityCode,
    ContractCode,
    Customer,
    CustomerCode,
    Remark
  ) {
    return request({
      url: '/Contract/GetContractNo',
      method: 'post',
      params: {
        CompanyEntityCode,
        ContractCode,
        Customer,
        CustomerCode,
        Remark,
      },
    });
  },
  /**
   * 复制合同信息
   * @param {*} contract_id guid 合同id
   * @returns
   */
  CopyContract(contract_id) {
    return request({
      url: '/Contract/CopyContract',
      method: 'post',
      params: {
        contract_id,
      },
    });
  },
  /**
   * 保存备注
   * @param {*}
   * @returns
   */
  SaveContractRemark(contract_id, type, remark) {
    return request({
      url: '/Contract/SaveContractRemark',
      method: 'post',
      params: {
        contract_id,
        type,
        remark,
      },
    });
  },
  /**
   * SaveVisualDate
   * @param {*} media_id
   * @param {*} visual_date
   * @returns
   */
  SaveVisualDate(media_id, visual_date) {
    return request({
      url: '/Contract/SaveVisualDate',
      method: 'post',
      params: {
        media_id,
        visual_date,
      },
    });
  },
  /**
   * 取消合同
   * @param {*} contract_id 合同guid
   * @returns
   */
  CancelContract(contract_id) {
    return request({
      url: '/Contract/CancelContract',
      method: 'post',
      params: {
        contract_id,
      },
    });
  },
  /**
   * 作废合同
   * @param {*} contract_id 合同guid
   * @param {*} remark 作废理由
   * @returns
   */
  VoidContract(contract_id, remark) {
    return request({
      url: '/Contract/VoidContract',
      method: 'post',
      params: {
        contract_id,
        remark,
      },
    });
  },
  /**
   * 更新合同日期
   * @param {*} contract_id
   */
  UpdateDate(contract_id) {
    return request({
      url: '/Contract/UpdateContractDate',
      method: 'post',
      params: {
        contract_id,
      },
    });
  },
};
